import React from "react";
import { connect } from "react-redux";
import { translate } from "../../../base/i18n";
import { equals } from "../../../base/redux";
import { isPropertyOpen, setVideoLayoutMode, videoLayoutMode } from "../../../video-layout-mode";

import AbstractSwitchButton from "../AbstractSwitchButton";

class SwitchCommonNoteButton extends AbstractSwitchButton {
    constructor(props) {
        super(props);

        this._onClick = this._onClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!equals(this.props.isShared, prevProps.isShared)) {
            if (this.props.isOption) APP.UI.closeModal();
        }
    }

    _onClick() {
        this.props.dispatch(setVideoLayoutMode(videoLayoutMode.white));
    }

    render() {
        const {
            t, isShared, isOption
        } = this.props;

        return (
            <>
                {isOption 
                    ? <dl className={`whiteBoardSwitch nonSelect`} onClick={this._onClick} >
                        <dt className="icoImg" />
                        <dd> {t(`options.${isShared}WhiteBoard`)} </dd>
                      </dl>
                    : isShared
                    ? <li onClick={this._onClick}>
                        <span className="btn btn_small">{t(`options.${isShared}WhiteBoard`)}</span> 
                      </li>
                    : null}
            </>
        )
    }
}

function _mapStateToProps(state) {
    return {
        isShared: isPropertyOpen(state, videoLayoutMode.note)
    }
}

export default translate(connect(_mapStateToProps)(SwitchCommonNoteButton));